export default __webpack_public_path__ + "static/Крысиные бега_2-61a2a1af9eba152757585b2bbaa52bb7.jpg";